import { useMemo } from 'react';
import {
  detectPlatform,
  storeHrefForPlatform,
} from '../src/utils/burokLinkDeeplink';

const BUROK_LOGO = '/assets/images/BUROKLOGOTWITTER.png';
const BUROK_BACKGROUND = '/assets/images/Burok gradient.png';

/** Accueil burok.shop / (sans code). */
export function ShortLinkDomainHomePage() {
  const platform = useMemo(() => detectPlatform(), []);
  const storeHref = storeHrefForPlatform(platform);

  return (
    <div
      className="flex flex-col items-center justify-center min-h-screen p-6 text-white bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url("${BUROK_BACKGROUND}")` }}
    >
      <img
        src={BUROK_LOGO}
        alt="Burok"
        className="w-24 h-24 mb-6 rounded-2xl shadow-lg"
      />
      <h1 className="text-2xl font-semibold text-center mb-2">Liens Burok</h1>
      <p className="text-center text-slate-300 max-w-md mb-8 text-[15px] leading-relaxed">
        Les liens courts sur ce domaine ouvrent l’application Burok. Scannez ou ouvrez un lien
        reçu pour continuer.
      </p>
      <a
        href={storeHref}
        className="inline-flex items-center justify-center gap-3 px-5 py-3 rounded-xl bg-black text-white font-medium hover:bg-neutral-900 transition-colors shadow-lg"
      >
        <img
          src={BUROK_LOGO}
          alt=""
          className="w-8 h-8 rounded-lg object-contain shrink-0"
          aria-hidden
        />
        Installer Burok
      </a>
    </div>
  );
}
